<div class="flex flex-auto w-full h-full dispatch-filter-content">
    <zuper-drawer class="border-l border-gray-300 shadow-none" [name]="drawerName" [mode]="'side'" [position]="'right'"
        [transparentOverlay]="true" (openedChanged)="drawerOpenedChanged($event)" [hideOnClickOutside]="false">
        <div class="dispatch-filter-container pointer-events-none right-0 flex max-w-full w-full h-full absolute"
           *ngIf="openFilter">
            <app-calendar-filter class="w-full h-full" [hideSaveFilter]="hideSaveFilter" [isNewFilter]="isNewFilter" [jobCalendarFilterValues]="jobCalendarFilterValues" [filterOptions]="filterOptions" [jobCalendarFilterValues]="jobCalendarFilterValues" 
            [saveFilterByDefault]="saveFilterByDefault" (filterEmitter)="filterEventHandler($event)"></app-calendar-filter>
        </div>
    </zuper-drawer>
</div>